import Process from '../process';

/**
 * Create the action
 */

const { thunk, request, success, error } = Process.update((data, fetch) => {


    if(data.uploadNewEvidence === true) {
        let formData = new FormData();

        Object.keys(data).map(function(key) {

            if(key == 'process') {
                formData.append(key, JSON.stringify(data[key]));
            } else if(key == 'image') {
                if(data[key].constructor === File) {
                    formData.append(key, data[key]);
                } else if(data[key] === null) {
                    return;
                }
            }
            else {
                formData.append(key, data[key]);
            }
            
        });

        return fetch.post('/upload-evidence', formData);
    } else if(data.destroyEvidence === true) {
        return fetch.post(`/destroy-evidence/${data.id}`);
    }
});

/**
 * Export the components
 */

export { thunk as default };
export { request, success, error };
